<template lang="pug">
.challenges-faq(style="padding-top: 0; margin-top: -20px;")
  .loading(v-if="loading")
    p {{ __('Loading FAQs...') }}

  template(v-else-if="cmsPage?.roguebuilder")
    component(
      v-for="(block, index) in contentBlocks"
      :is="RenderBlock"
      :key="index"
      :block="block"
    )

  p.no-content(v-else) {{ __('Content not available.') }}
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'
import { useCmsStore } from '@/js/stores/cmsStore'
import { messages } from '@/js/app-bridge/messages'
import RenderBlock from 'sisu/components/RenderBlock'

const router = useRouter()
const rogue = useRogue()
const cmsStore = useCmsStore()

const loading = ref(true)
const cmsPage = ref<any>(null)

const CMS_PAGE_URL = '/challenges/faqs'

const contentBlocks = computed(() => {
  const rb = cmsPage.value?.roguebuilder
  if (!rb) return []
  if (Array.isArray(rb)) return rb
  if (rb.slots?.default) return rb.slots.default
  return [rb]
})

async function loadCmsContent() {
  loading.value = true
  try {
    const routeData = await rogue.api.fetch<{ cmsId?: number }>({
      url: `/svc_route/route?url=${CMS_PAGE_URL}`,
    })
    if (routeData?.cmsId) {
      cmsPage.value = await cmsStore.load(routeData.cmsId, rogue)
    }
  } catch (e) {
    rogue.log.error('Error loading challenges FAQ CMS content', e)
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  if (!rogue.appContext && !rogue.featureFlags.isOn('invitational_app_display')) {
    router.replace('/challenges/faqs')
    return
  }
  await loadCmsContent()
  if (rogue.appContext) {
    rogue.emitToApp(messages.DOM_LOADED, {})
  }
})
</script>

<style lang="scss" scoped>
.challenges-faq {
  min-height: 100vh;
  background: $color-white;
}

.loading,
.no-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: $space-xl;
  color: $color-gray-dark;
}
</style>

<style lang="scss">
.platform-ios, .platform-android {
  .challenges-faq {
    padding-top: $space-xs;
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 120px);
  }

  // Hide content not meant for native app (CMS visibility control)
  .rogue-hide:not(.rg-show-native) {
    display: none;
  }
}
</style>
